module.exports = __webpack_public_path__ + "media/img/pages/companies/ms-f1235049de760d45e05e00c834341476.png";